import {IconSlugMobile} from '@yandex-delivery/bound-card/src/constants/icon-slug@mobile'
import {tag2url} from '@yandex-delivery/utils'
import {CardSystem} from '@yandex-delivery/api/model/payment'

const mapCardSystemToIconSrc: Record<CardSystem, IconSlugMobile> = {
  maestro: IconSlugMobile.MAESTRO,
  mastercard: IconSlugMobile.MASTERCARD,
  mir: IconSlugMobile.MIR,
  unknown: IconSlugMobile.UNKNOWN,
  visa: IconSlugMobile.VISA,
}

export const getIconSrc = (system?: CardSystem): string => tag2url(mapCardSystemToIconSrc[system ?? 'unknown'])
